// START_MODULE pages_main_sections_statistics_styled_ts
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import styled, { css } from 'styled-components';

export const StatisticsSectionContainer = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.accentColor};
    padding: 40px 0;

    display: flex;
    justify-content: center;
    gap: 40px;

    @media (max-width: 900px) {
      gap: 0;
    }
    @media (max-width: 600px) {
      display: grid;
      grid-template-columns: 1fr 1fr;
      justify-items: center;
      grid-row-gap: 16px;
    }
    @media (max-width: 370px) {
      grid-template-columns: 1fr;
    }
  `};
`;

// END_MODULE pages_main_sections_statistics_styled_ts
